import { legendAutoLayout, generateTicks } from './legendLayout'

export const VIEW = {
  top: {
    up: [0, 1, 0],
    direction: [0, 0, 1]
  },
  bottom: {
    up: [0, -1, 0],
    direction: [0, 0, -1]
  },
  left: {
    up: [0, 0, 1],
    direction: [-1, 0, 0],
  },
  right: {
    up: [0, 0, 1],
    direction: [1, 0, 0],
  },
  front: {
    up: [0, 0, 1],
    direction: [0, -1, 0],
  },
  back: {
    up: [0, 0, 1],
    direction: [0, 1, 0],
  }
}


// set up global legend
// This is set to match the font settings on Ant Design
export const FONT = '-apple-system, BlinkMacSystemFont, Segoe UI, Roboto, Helvetica Neue, Arial, Noto Sans, sans-serif, Apple Color Emoji, Segoe UI Emoji, Segoe UI Symbol, Noto Color Emoji'

export const LEGEND_DEFAULTS = {
  automated: true,
  autoLayout: legendAutoLayout(),
  generateTicks,
  axisTextStyle: {
    fontColor: '#343D45',
    fontStyle: 'normal',
    // fontSize: '10',
    fontFamily: FONT
  },
  tickLabelPixelOffset: 14.0,
  tickTextStyle: {
    fontColor: '#343D45',
    fontStyle: 'normal',
    // fontSize: '10',
    fontFamily: FONT
  }
}

export const DEFAULT_COLORSET = 'Original Ladybug'

export const COLORSET_REGEXP = /(\sw\/\s*)|[^\w]|_/g